import { viewsActionType } from "../../constants";


const ColumnsViewDetailsReducer = (state = [], action) => {
    switch (action.type) {
        case viewsActionType.FETCH_VIEW:
            return action.payload;
        default:
            return state;
    }
};
export default ColumnsViewDetailsReducer